// extracted by mini-css-extract-plugin
export default {"summary":"Payslip_summary__KCIWu","pay":"Payslip_pay__du4EW"};